import PontType from 'owa-service/lib/contract/PontType';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { updateUserConfigurationAndService } from 'owa-session-store/lib/utils/updateUserConfigurationAndService';

export default function updateUserConfigurationPont(pontType: PontType) {
    const newEnabledPontsValue = getUserConfiguration().UserOptions.NewEnabledPonts & ~pontType;
    updateUserConfigurationAndService(
        config => {
            config.UserOptions.NewEnabledPonts = newEnabledPontsValue;
        },
        [{ key: 'NewEnabledPonts', valuetype: 'Integer32', value: [`${newEnabledPontsValue}`] }]
    );
}
